/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PressReleaseBusinessCategoryLv2,
    PressReleaseBusinessCategoryLv2FromJSON,
    PressReleaseBusinessCategoryLv2FromJSONTyped,
    PressReleaseBusinessCategoryLv2ToJSON,
} from './PressReleaseBusinessCategoryLv2';

/**
 * プレスリリースビジネスカテゴリ（大分類）
 * @export
 * @interface PressReleaseBusinessCategory
 */
export interface PressReleaseBusinessCategory {
    /**
     * ビジネスカテゴリ名
     * @type {string}
     * @memberof PressReleaseBusinessCategory
     */
    busiCateName: string;
    /**
     * ビジネスカテゴリ lv2 (小分類)
     * @type {Array<PressReleaseBusinessCategoryLv2>}
     * @memberof PressReleaseBusinessCategory
     */
    lv2: Array<PressReleaseBusinessCategoryLv2>;
}

export function PressReleaseBusinessCategoryFromJSON(json: any): PressReleaseBusinessCategory {
    return PressReleaseBusinessCategoryFromJSONTyped(json, false);
}

export function PressReleaseBusinessCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): PressReleaseBusinessCategory {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'busiCateName': json['busi_cate_name'],
        'lv2': ((json['lv2'] as Array<any>).map(PressReleaseBusinessCategoryLv2FromJSON)),
    };
}

export function PressReleaseBusinessCategoryToJSON(value?: PressReleaseBusinessCategory | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'busi_cate_name': value.busiCateName,
        'lv2': ((value.lv2 as Array<any>).map(PressReleaseBusinessCategoryLv2ToJSON)),
    };
}

